import styled from '@emotion/styled';
import { useTranslation } from 'react-i18next';
import { useNavigation } from '../../hooks/useNavigation';

interface HomeButtonProps {
  className?: string;
  left?: string;
}

const HomeButton = ({ className, left = '40px' }: HomeButtonProps) => {
  const { t } = useTranslation();
  const { navigateToStart } = useNavigation();

  return (
    <Button onClick={navigateToStart} className={className} left={left}>
      <HomeIcon />
      <Text>{t('common.home')}</Text>
    </Button>
  );
};

const HomeIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M3 12L5 10M5 10L12 3L19 10M5 10V20C5 20.5523 5.44772 21 6 21H9M19 10L21 12M19 10V20C19 20.5523 18.5523 21 18 21H15M9 21C9.55228 21 10 20.5523 10 20V16C10 15.4477 10.4477 15 11 15H13C13.5523 15 14 15.4477 14 16V20C14 20.5523 14.4477 21 15 21M9 21H15"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const Button = styled.button<{ left: string }>`
  position: absolute;
  top: 20px;
  left: ${(props) => props.left};
  z-index: 1000;
  width: auto;
  min-width: 80px;
  height: 40px;
  padding: 12px 16px;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
  background-color: white;
  cursor: pointer;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  color: #000000;

  &:hover {
    border-color: #3b82f6;
    box-shadow: 0 2px 8px rgba(59, 130, 246, 0.1);
    color: #3b82f6;
  }

  &:focus {
    outline: none;
    border-color: #3b82f6;
    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.2);
  }
`;

const Text = styled.span`
  font-size: 14px;
  font-weight: 500;
`;

export default HomeButton;
